const guard = {
    invalid_input: "La requête {{type}} n'est pas valide.",
    invalid_pagination: "La valeur de la pagination de la requête n'est pas valide.",
    can_not_get_tenant_id: "Impossible de récupérer l'identifiant du locataire à partir de la demande.",
    file_size_exceeded: 'Taille du fichier dépassée.',
    mime_type_not_allowed: "Le type MIME n'est pas autorisé.",
};
export default guard;
